import React, { useEffect, useState, useRef } from 'react';
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
  TableInstance,
} from 'react-table';
import { useNavigate } from 'react-router-dom';
import SelectField from 'components/fields/SelectField';

import {
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Box,
  Button,
  SimpleGrid,
  Tooltip,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { getCompanyList, getSelectCreator } from 'utils/creator/creator';

import {
  getAllQuestAnalytics
} from 'utils/activitycontrols/activities';
import { getGameList } from 'utils/game/gameService';
import { getcohortslist } from 'utils/cohorts/cohorts';
import { SearchIcon } from '@chakra-ui/icons';
import InputField from 'components/fields/InputField';
import { HashLoader } from 'react-spinners';
import {
  IconButton,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
} from '@chakra-ui/react';

interface LearnerActivityData {
  sNo: number;
  lenUserName: string;
  lenMail: string;

  gameTitle: string;
  createdDate: any;
  cohortName: any;

}
type RowObj = {
  sNo: number;
  lenUserName: string;
  lenMail: string;
 
  gameTitle: string;
  createdDate: any;
  cohortName: any;
  quest1:any;
  quest2:any;
  quest3:any;
  quest4:any;
 
};

interface OptionType {
  value: string;
  label: string;
}
interface ColumnObj {
  Header: number | string;
  accessor: keyof RowObj;
}
interface planType {
  plPlan: string;
  plId: string;
  // other properties if any
}
type DataCol = TableInstance<RowObj>;
interface CustomLearnerDataTableProps {
  data: RowObj[];
  setApiData: React.Dispatch<React.SetStateAction<LearnerActivityData[]>>;
  setCompany: any;
  apiData: LearnerActivityData[];
  //  games:any[];
  setGames: any;
  setcohort: any;
  isToggled: any;
  setIsToggled: any;
  //  setgamename:any;
}

const LearnerActivityDataTable: React.FC<CustomLearnerDataTableProps> = ({
  data,
  setApiData,
  setCompany,
  // setgamename,
  apiData,
  setGames,
  setcohort,
  isToggled,
  setIsToggled,
}) => {
  const storage = JSON.parse(localStorage.getItem('user'));

  let storageCreatorId = '';
  const UserRole = storage.data.role;
  if (storage.data.role === 'Creator') {
    storageCreatorId = storage.data.id;
  }
  let storagelenNameId = '';
  
  if (storage.data.role === 'Creator') {
    storagelenNameId = storage.data.id;
  }
  const [lastPage, setLastPage] = useState<any>();

  const [companyOptions, setCompanyOptions] = useState([]);
  const [loadingdata, setLoadingdata] = useState(false);

  const [creatorOptions, setCreatorOptions] = useState([]);

  const [selected, setSelected] = useState({
    companyId: '',
    creatorId: '',
    lenUserName: '',
    galGameId: '',
    cohortId: '',
    // date: '',
     fromDate: '',
  toDate: '',
  });

  const [filteredCreators, setFilteredCreators] = useState([]);
  const [filteredGameOptions, setFilteredGameOptions] = useState([]);
  console.log(filteredGameOptions,'filteredGameOptions')

  const [creators, setCreators] = useState([]);
  const [GameOptions, setGameOptions] = useState([]);

  const [cohortOption, setCohortOption] = useState([]);

console.log(GameOptions,'GameOptions')
  const navigate = useNavigate();
  const searchIconColor = useColorModeValue('gray.700', 'white');
  let menuBg = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  interface OptionTypecon {
    value: string;
    label: string;
    CompanyId: string;
    lenUserName: string;
    galGameId: string;
    cohortId: string;
  }





const [searchText, setSearchText] = useState('');
const [pageIndexState, setPageIndexState] = useState(0);
const [totalPages, setTotalPages] = useState(0);



  // const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setSelected({
  //     ...selected,
  //     date: event.target.value,
  //   });
  // };
  const fixedColumnsCount = UserRole === 'Admin' ? 6 : 4;

  const columns: ColumnObj[] = React.useMemo(() => {
    let userRoleColumns: ColumnObj[] = [];

    if (UserRole === 'Creator') {
      userRoleColumns = [
        { Header: 'sNo', accessor: 'sNo' },
        { Header: 'learnerName', accessor: 'lenUserName' },
        { Header: 'learnerMail', accessor: 'lenMail' },
      
        { Header: 'GameTitle', accessor: 'gameTitle' },
        { Header: 'AssignedDate', accessor: 'createdDate' },
        { Header: 'CohortName', accessor: 'cohortName' },
        { Header: 'Quest 1', accessor: 'quest1' },
        { Header: 'Quest 2', accessor: 'quest2' },
        { Header: 'Quest 3', accessor: 'quest3' },
        { Header: 'Quest 4', accessor: 'quest4' },
      
      
      ];
    } else if (UserRole === 'Admin') {
      userRoleColumns = [
        { Header: 'sNo', accessor: 'sNo' },
        { Header: 'learnerName', accessor: 'lenUserName' },
        { Header: 'learnerMail', accessor: 'lenMail' },
     
        { Header: 'GameTitle', accessor: 'gameTitle' },
        { Header: 'AssignedDate', accessor: 'createdDate' },
        { Header: 'CohortName', accessor: 'cohortName' },
          { Header: 'Quest 1', accessor: 'quest1' },
        { Header: 'Quest 2', accessor: 'quest2' },
        { Header: 'Quest 3', accessor: 'quest3' },
        { Header: 'Quest 4', accessor: 'quest4' },
      
      ];
    }

    return userRoleColumns;
  }, [UserRole]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
    gotoPage,
    setPageSize,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
  }: DataCol = useTable<RowObj>(
    {
      columns,
      data: data,
      // initialState: { pageIndex: 0, pageSize: 10 },
       manualPagination: true,   // ✅ IMPORTANT
    pageCount: totalPages,   // ✅ IMPORTANT
    // initialState: { pageIndex: 0, pageSize: 10 },
      state: { pageIndex: pageIndexState }, 
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );
  const mappedPlanOptions = Array.isArray(creators)
    ? creators.map((creators) => ({
        value: creators.plId,
        label: creators.plPlan,
      }))
    : [];
  // useEffect(() => {
  //   const lastPage = Math.floor(data.length / pageSize);
  //   setLastPage(Math.floor(data.length / pageSize));
  // }, []);
useEffect(() => {
  setLastPage(Math.floor(data.length / pageSize));
}, [data, pageSize]);
  // const totalPages = Math.ceil(data.length / pageSize);

  // const handleGoPage = (pageNumber: number) => {
  //   if (pageNumber >= 0 && pageNumber < totalPages) {
  //     gotoPage(pageNumber);
  //   }
  // };
useEffect(() => {
  gotoPage(pageIndexState);
}, [pageIndexState]);
  const handleGoPage = (pageNumber: number) => {
  if (pageNumber >= 0 && pageNumber < totalPages) {
    setPageIndexState(pageNumber); // ✅ trigger API
  }
};

  // const getPageNumbers = () => {
  //   const pageCount = 3;
  //   const currentPage = pageIndex + 1;
  //   const pages = [];

  //   if (totalPages <= pageCount) {
  //     // Display all pages if total pages are less than or equal to the page count
  //     for (let i = 0; i < totalPages; i++) {
  //       pages.push(i + 1);
  //     }
  //   } else {
  //     const start = Math.max(1, currentPage - Math.floor(pageCount / 2));
  //     const end = Math.min(totalPages, start + pageCount - 1);

  //     if (start > 1) {
  //       pages.push(1, '...');
  //     }

  //     for (let i = start; i <= end; i++) {
  //       pages.push(i);
  //     }

  //     if (end < totalPages) {
  //       pages.push('...', totalPages);
  //     }
  //   }

  //   return pages;
  // };


  const getPageNumbers = () => {
  const pages = [];
  const visiblePages = 5; // how many numbers you want visible
  const currentPage = pageIndexState + 1;

  let start = Math.max(1, currentPage - Math.floor(visiblePages / 2));
  let end = Math.min(totalPages, start + visiblePages - 1);

  // Adjust start if we're near the end
  if (end === totalPages) {
    start = Math.max(1, totalPages - visiblePages + 1);
  }

  // First page + dots
  if (start > 1) {
    pages.push(1);
    if (start > 2) pages.push("...");
  }

  // Main pages
  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  // Last page + dots
  if (end < totalPages) {
    if (end < totalPages - 1) pages.push("...");
    pages.push(totalPages);
  }

  return pages;
};
  useEffect(() => {
    const fetchData = async () => {
      try {
       

        const company = await getCompanyList();
        setCompanyOptions(company?.data);
        setCompany(company?.data);
        if (company?.status !== 'Success')
          return console.log('getCountries Error:', company?.message);
        const game = await getGameList();
console.log(game,'gamelist')
        if (game?.status !== 'Success')
          return console.log('getCountries Error :', game?.message);

        setGameOptions(game?.data);
        setGames(game?.data);

        const cohort = await getcohortslist();

        if (cohort?.status !== 'Success')
          return console.log('getCountries Error :', cohort?.message);
        setCohortOption(cohort?.data);
        setcohort(cohort?.data);

        const creator = await getSelectCreator(); // Replace with your actual function to get plan names

        if (creator?.status !== 'Success')
          return console.log('getPlanNames Error:', creator?.message);
        setCreatorOptions(creator.data);
        setCreators(creator.data);
        // Set default values based on user role

        if (UserRole === 'Creator') {
          const selectCreatorData: OptionTypecon[] = creator?.data || [];
          const foundCompany = selectCreatorData.find(
            (item) => item.value === storageCreatorId,
          );

          // Populate the selected state with company and creator details
          if (foundCompany) {
            setSelected({
              ...selected,
              companyId: foundCompany.CompanyId,
              creatorId: foundCompany.value,
            });
          }
        }
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Fetch data as before...

    if (UserRole === 'Admin' || UserRole === 'Creator') {
      const initialFiltered = UserRole === 'Creator' ? creators : [];
      setFilteredCreators(initialFiltered);
    }
  }, [UserRole, creators]);

  useEffect(() => {
    // Check if GameOptions contains games
  }, [GameOptions]);

  useEffect(() => {
    // Check if GameOptions contains data
    if (!GameOptions || GameOptions.length === 0) {
      console.log('No games to filter');
      return;
    }

    if (selected.creatorId) {
    //   const filteredGames = GameOptions.filter(
    //     (game) => game.key === selected.creatorId,
    //   );
    //   console.log(filteredGames,'filteredGames')
    //   setFilteredGameOptions(filteredGames);
    // } else {
      setFilteredGameOptions(GameOptions);
    }
  }, [selected.creatorId, GameOptions]);

  const handleGameChange = (selectedOption: OptionTypecon | null) => {
    setSelected({
      ...selected,
      galGameId: selectedOption.value,
    });
  };


  const handleCompanyChange = (selectedOption: OptionTypecon | null) => {
    setSelected({
      ...selected,
      companyId: selectedOption.value,
      creatorId: '',
      galGameId: '',
      cohortId: '',
    });
  };

  const handleCreatorIdChange = (selectedOption: OptionTypecon | null) => {
    if (selectedOption) {
      setSelected({
        ...selected,
        creatorId: selectedOption.value,
        companyId: selectedOption.CompanyId,
        galGameId: '', // Reset gameId when a new creator is selected
      });
    } else {
      setSelected({
        ...selected,
        creatorId: '',
        galGameId: '', // Reset gameId when no creator is selected
      });
    }
  };


  const handleCohortChange = (selectedOption: OptionType | null) => {
    setSelected({ ...selected, cohortId: selectedOption?.value });
  };

 
const initialDataLoadedRef = useRef(false);
  const isFetchingRef = useRef(false);

  const handleClick = async () => {
  if (isFetchingRef.current) return; 
  isFetchingRef.current = true;
  setLoadingdata(true);

  try {
    let foundCompany: any = [];
    if (UserRole === "Creator") {
      const selectCreatorData: OptionTypecon[] = creatorOptions || [];
      foundCompany = selectCreatorData.find(
        (item) => item.value === storageCreatorId
      );
    }

    let data = JSON.stringify({
      ...selected,
      companyId: selected.companyId
        ? selected.companyId
        : foundCompany?.CompanyId,
      creatorId: selected.creatorId
        ? selected.creatorId
        : foundCompany?.value,
      galGameId: selected.galGameId,
      cohortId: selected.cohortId,
        fromDate: selected.fromDate,
  toDate: selected.toDate,
   page: pageIndexState + 1,
    search: searchText,
  limit: pageSize,
    });

    const result = await getAllQuestAnalytics(data);
setTotalPages(result.totalPages);
    if (result?.status !== "Success") {
      setApiData([]);
      return;
    }

    setApiData(
      result?.data.map((item: any) => ({
        ...item,
        sNo: item.sNo,
        lenUserName: item.lenUserName,
        lenMail: item.lenMail,
       
        gameTitle: item.gameTitle,
        createdDate: item.createdDate,
        cohortName: item.cohortName,

      }))
    );
  } catch (error) {
    console.error("Error fetching learners:", error);
    setApiData([]);
  } finally {
    setLoadingdata(false);
    setTimeout(() => {
      isFetchingRef.current = false;
    }, 300);
  }
};

useEffect(() => {
  const delay = setTimeout(() => {
    setPageIndexState(0); // reset to page 1
    handleClick();
  }, 500);

  return () => clearTimeout(delay);
}, [searchText]);
// ✅ Initial data load only once
useEffect(() => {
  const fetchInitialData = async () => {
    try {
      const [company, creator, game, cohort] = await Promise.all([
        getCompanyList(),
        getSelectCreator(),
        getGameList(),
        getcohortslist(), // ✅ Corrected name
      ]);

      setCompanyOptions(company?.data || []);
      setCreatorOptions(creator?.data || []);
      setGameOptions(game?.data || []);
      setCohortOption(cohort?.data || []); // ✅ Corrected setter name

      if (UserRole === "Creator") {
        const foundItem = creator?.data.find(
          (item:any) => item.value === storageCreatorId
        );
        if (foundItem) {
          setSelected((prev) => ({
            ...prev,
            companyId: foundItem.CompanyId,
            creatorId: foundItem.value,
          }));
        }
      }

      initialDataLoadedRef.current = true; // ✅ Mark complete
    } catch (err) {
      console.error("Initial Data Load Error:", err);
    }
  };

  fetchInitialData();
}, []);

// ✅ Trigger after data ready
useEffect(() => {
  if (!initialDataLoadedRef.current) return;

  if (UserRole === "Creator") {
    if (selected.companyId && selected.creatorId) {
      handleClick();
    }
  } else if (selected.companyId) {
    handleClick();
  }
}, [
  selected.companyId,
  selected.creatorId,
  selected.lenUserName,
  selected.galGameId,
  selected.cohortId,
  // selected.date,
    selected.fromDate, // 👈 update
  selected.toDate,
  isToggled,
   pageIndexState  
]);



// double time api controll kishore end code 
  useEffect(() => {
    if (selected.companyId) {
      const filteredCreators = creatorOptions.filter(
        (option: any) => option.CompanyId === selected.companyId,
      );

      const filteredGames = filteredGameOptions.filter((game) =>
        filteredCreators.some((creator) => creator.value === game.key),
      );
      setFilteredGameOptions(filteredGames);
    }
  }, [selected.companyId]);

  useEffect(() => {
    if (selected.creatorId) {
      const filteredCreators = creatorOptions.find(
        (option) => option.value === selected.creatorId,
      );

      const filteredGames = filteredGameOptions.filter(
        (option: any) => option.key === selected.creatorId,
      );
      setFilteredGameOptions(filteredGames);
    }
  }, [selected.creatorId]);



  const [isHovering, setIsHovering] = useState(false);
  const tableRef = useRef<HTMLDivElement | null>(null);

  // Prevent scrolling of body when mouse is inside table
  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      if (isHovering && tableRef.current) {
        // Prevent vertical scroll on body
        if (e.deltaY !== 0) {
          e.preventDefault();
          // Scroll horizontally based on vertical scroll movement
          tableRef.current.scrollLeft += e.deltaY;
        }
      }
    };

    // Add event listener for scroll on window
    if (isHovering) {
      window.addEventListener('wheel', handleWheel, { passive: false });
    } else {
      window.removeEventListener('wheel', handleWheel);
    }

    return () => {
      // Cleanup the event listener
      window.removeEventListener('wheel', handleWheel);
    };
  }, [isHovering]);
  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };
  return (
    <>
      {loadingdata && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
    
      <Card mt={'20px'} width={'100%'}>
        <SimpleGrid
          columns={{ base: 1, md: 3, lg: 3 }}
          // ml="30px"
          spacing={6}
        >
          {/* fsdfdsa */}

          {UserRole === 'Admin' || UserRole === 'Creator' ? (
            <>
              <SelectField
                mb="0px"
                id="ctCompanyId"
                name="companyId"
                label="Company Name"
                options={companyOptions}
                onChange={handleCompanyChange}
                value={
                  companyOptions.find(
                    (option) => option.value === selected.companyId,
                  ) || null
                }
                isDisabled={storage.data.role === 'Creator'}
                isClearable={true}
              />
              <SelectField
                mb="0px"
                id="ctCreator"
                name="ctCreator"
                label="Creator Name"
               
                options={
                  selected.companyId
                    ? creatorOptions.filter(
                        (option: any) =>
                          option.CompanyId === selected.companyId,
                      )
                    : creatorOptions
                }
                onChange={handleCreatorIdChange}
                // value={
                //   creatorOptions.find(
                //     (option) => option.value === selected.creatorId,
                //   ) || null
                // }
                isClearable={true}
              />

              <SelectField
                mb="0px"
                id="gameId"
                name="gameID"
                label="Game Name"
                options={filteredGameOptions}
                onChange={handleGameChange}
                value={
                  filteredGameOptions.find(
                    (option) => option.value === selected.galGameId,
                  ) || null
                }
                isClearable={true}
              />

              {/* <InputField
                mb="0px"
                name="Date"
                label="Assigned Date"
                type="date"
                onChange={handleDateChange}
              /> */}
                <InputField
  name="From Date"
  label="From Date"
  type="date"
  onChange={(e:any) =>
    setSelected({ ...selected, fromDate: e.target.value })
  }
/>

<InputField
  name="To Date"
  label="To Date"
  type="date"
  onChange={(e:any) =>
    setSelected({ ...selected, toDate: e.target.value })
  }
/>

              <SelectField
                mb="0px"
                id="ctCompanyId"
                name="planId"
                label="Cohorts"
                // options={cohorts}
                options={
                  selected.companyId
                    ? cohortOption.filter(
                        (option: any) =>
                          option.companyId === selected.companyId,
                      )
                    : cohortOption
                }
                onChange={handleCohortChange}
                value={
                  cohortOption.find(
                    (option) => option.value === selected.cohortId,
                  ) || null
                }
                isClearable={true}
              />
            </>
          ) : null}

         
        </SimpleGrid>
      </Card>
    

      <Flex
        justifyContent={{
          base: 'center',
          sm: 'flex-end',
          md: 'flex-end',
          lg: 'flex-end',
        }}
        align={'center'}
        mb={'10px'}
        p={'20px 0'}
      >
        <Flex
          w={{ sm: '100%', md: 'auto' }}
          alignItems="center"
          flexDirection={{ xs: 'column', sm: 'row', md: 'row', lg: 'row' }}
          bg={menuBg}
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
          p="10px"
          borderRadius="20px"
          boxShadow={shadow}
        >
          <InputGroup w={{ base: '100%', sm: '100%', md: '200px' }}>
            <InputLeftElement
              children={
                <IconButton
                  aria-label="search"
                  bg="inherit"
                  borderRadius="inherit"
                  _active={{
                    bg: 'inherit',
                    transform: 'none',
                    borderColor: 'transparent',
                  }}
                  _hover={{
                    background: 'none',
                  }}
                  _focus={{
                    background: 'none',
                    boxShadow: 'none',
                  }}
                  icon={
                    <SearchIcon color={searchIconColor} w="15px" h="15px" />
                  }
                />
              }
            />
            <Input
              type="text"
              placeholder="Search..."
               value={searchText}
  onChange={(e) => setSearchText(e.target.value)}
              // value={globalFilter || ''}
              // onChange={(e) => setGlobalFilter(e.target.value)}
              bg={'#f9f9f9'}
              borderRadius={'14px'}
              w={{ base: '100%', sm: '100%', xl: '300px' }}
            />
          </InputGroup>

       
        </Flex>
      </Flex>
      <Box
        ref={tableRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        overflowX="auto"
        overflowY={isHovering ? 'hidden' : 'scroll'} // Disable vertical scroll when inside table
        padding="2px"
        borderRadius={'13px 13px 20px 20px'}
      >
        <Table
          {...getTableProps()}
          variant={'simple'}
          overflowX={{ base: 'auto', xl: 'unset' }}
          style={{
            border: '2px solid #f7f7f7',
          }}
        >
          <Thead className="thead" bg={'#f9f9f9'}>
            {headerGroups.map((headerGroup) => (
              <Tr
                {...headerGroup.getHeaderGroupProps()}
                borderBottom={'2px solid #f7f7f7'}
              >
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    color={'#191919'}
                    textAlign={'start'}
                    p={'10px 10px'}
                  >
                    {column.render('Header')}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? ' 🔽'
                          : ' 🔼'
                        : ''}
                    </span>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()} fontSize={'17px'}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} borderBottom={'2px solid #f7f7f7'}>
                  {row.cells.map((cell) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        className="learnerForAction"
                        p={'12px'}
                        textAlign={'start'}
                        style={{ backgroundColor: 'white' }}
                      >
                        {cell.render('Cell')}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Box>
      <Box
        p={'20px 5px'}
        display={{ base: 'block', xl: 'flex' }}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Box mb={5}>
          <Box mr={'10px'} color={'#000'}>
            <span style={{ color: '#20212396' }}>
              Page{' '}
              <span>
                {/* {pageIndex + 1} of {Math.ceil(data.length / pageSize)}
                 */}
                 {pageIndexState + 1} of {totalPages}
              </span>{' '}
            </span>
          </Box>
        </Box>
        <Box display={{ base: 'flex', xl: 'flex' }}>
          <Box mr={'10px'} display={'flex'} alignItems={'center'}>
            <Button
              // onClick={() => previousPage()}
              onClick={() => handleGoPage(pageIndexState - 1)}
              // disabled={!canPreviousPage}
              disabled={pageIndexState === 0}
              bg={'#f3f0f0'}
              mr={'5px'}
              h={'40px'}
              w={'40px'}
              borderRadius="50%"
              lineHeight="1em"
              flexShrink={0}
              fontWeight={800}
            >
              {'<'}
            </Button>{' '}
            {getPageNumbers().map((page, index) => (
              <Button
                key={index}
                mr={'5px'}
                h={'40px'}
                w={'40px'}
                borderRadius="100px"
                lineHeight="1em"
                flexShrink={0}
                fontWeight={800}
                background={pageIndexState + 1 === page ? '#3311db' : 'unset'}
color={pageIndexState + 1 === page ? '#fff' : 'unset'}
                // background={pageIndex + 1 === page ? '#3311db' : 'unset'}
                // color={pageIndex + 1 === page ? '#fff' : 'unset'}
                onClick={() =>
                  typeof page === 'number' ? handleGoPage(page - 1) : null
                }
              >
                {page}
              </Button>
            ))}
            <Button
              // onClick={() => nextPage()}
              onClick={() => handleGoPage(pageIndexState + 1)}
              // disabled={!canNextPage}
              disabled={pageIndexState + 1 >= totalPages}
              bg={'#f3f0f0'}
              h={'40px'}
              w={'40px'}
              borderRadius="100px"
              lineHeight="1em"
              flexShrink={0}
              fontWeight={800}
            >
              {'>'}
            </Button>{' '}
          </Box>
          <Box></Box>
        </Box>
      </Box>
    </>
  );
};

export default LearnerActivityDataTable;
